<template>
  <div class="readiness-checklist">
    <div
      v-for="(item, index) in items"
      :key="item.key || index"
      class="readiness-checklist__row"
    >
      <FontAwesomeIcon
        :icon="['fas', icon(item.status)]"
        fixed-width
        class="readiness-checklist__icon"
        :class="`readiness-checklist__icon--${item.status}`"
      />
      <span class="readiness-checklist__label">{{ item.label }}</span>
      <small v-if="item.meta">{{ item.meta }}</small>
    </div>
    <el-button
      v-if="actionLabel"
      class="readiness-checklist__action"
      size="mini"
      :disabled="actionDisabled"
      @click="$emit('action')"
    >
      <FontAwesomeIcon
        v-if="actionIcon"
        :icon="actionIcon"
        fixed-width
      />
      {{ actionLabel }}
    </el-button>
  </div>
</template>

<script>
const STATUS_ICONS = {
  pending: 'clock',
  success: 'check-circle',
  warning: 'exclamation-triangle',
  danger: 'exclamation-circle'
}

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    actionLabel: {
      type: String,
      default: ''
    },
    actionDisabled: {
      type: Boolean,
      default: false
    },
    actionIcon: {
      type: [String, Array],
      default: null
    }
  },
  methods: {
    icon (status) {
      return STATUS_ICONS[status] || STATUS_ICONS.pending
    }
  }
}
</script>

<style lang="scss" scoped>
.readiness-checklist__row {
  align-items: center;
  border-bottom: 1px solid #ebeef2;
  display: grid;
  gap: 8px;
  grid-template-columns: 18px 1fr auto;
  min-height: 43px;
}

.readiness-checklist__label {
  color: #303844;
  font-size: 12px;
}

.readiness-checklist__row small {
  color: #9298a1;
  text-align: right;
}

.readiness-checklist__icon {
  color: #77808c;

  &--success {
    color: #2f8f6b;
  }

  &--warning {
    color: #b67808;
  }

  &--danger {
    color: #bd4545;
  }
}

.readiness-checklist__action {
  margin-top: 12px;
  width: 100%;
}

@media (max-width: 480px) {
  .readiness-checklist__row {
    grid-template-columns: 18px 1fr;
    padding: 8px 0;
  }

  .readiness-checklist__row small {
    grid-column: 2;
    text-align: left;
  }
}
</style>
